import {Component, Input, OnInit} from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import {Observable} from "rxjs";
import {ApiService, ChatbotDef, RagSimilaritySearchCollectionResult} from "../../../services/api.service";
import {ActivatedRoute, Params, Router, RouterLink} from "@angular/router";
import {RouteContainerComponent} from "../../../core/route-container/route-container.component";
import {JsonPipe, NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase} from "@angular/common";
import {LoaderContainerComponent} from "../../../core/loader-container/loader-container.component";
import {MatTabsModule} from "@angular/material/tabs";
import {MatCardModule} from "@angular/material/card";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {DataTableComponent} from "../../../core/data-table/data-table.component";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatIconModule} from "@angular/material/icon";
import {UptimeViewComponent} from "../../../core/uptime-view/uptime-view.component";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {ErrorPanelComponent} from "../../../core/error-panel/error-panel.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";

@Component({
  selector: 'app-chatbot-context-dashboard',
  standalone: true,
  imports: [
    RouteContainerComponent,
    NgIf,
    LoaderContainerComponent,
    JsonPipe,
    MatTabsModule,
    NgForOf,
    RouterLink,
    NgSwitch,
    NgSwitchCase,
    MatCardModule,
    ActionsContainerComponent,
    DataTableComponent,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    NgClass,
    UptimeViewComponent,
    MatProgressBarModule,
    ErrorPanelComponent,
    BackButtonComponent
  ],
  templateUrl: './chatbot-context-dashboard.component.html'
})
export class ChatbotContextDashboardComponent implements OnInit {

  @Input() hideActions = false
  @Input() color: ThemePalette

  readonly tabs: string[] = ['Similarity Search', 'Variables']
  activeTab: string = 'Similarity Search'
  chatbotUuid?: string
  loader?: Observable<ChatbotDef>
  chatbot?: ChatbotDef
  searchForm: FormGroup
  searchResultTab: string | null = null
  searchResults?: RagSimilaritySearchCollectionResult[]
  searchResultVars: string[] = []
  searchResultsActive?: RagSimilaritySearchCollectionResult
  searchResultsTotal = 0
  searchDuration: number = 0
  loading = false
  error: any

  constructor(
    readonly api: ApiService,
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly fb: FormBuilder,
  ) {
    this.searchForm = this.fb.group({
      prompt: ['']
    })
  }

  ragSearch() {
    if (this.searchForm.valid) {
      const prompt: string = this.searchForm.value['prompt']
      if (prompt.length) {
        const start = new Date()
        this.loading = true
        this.error = undefined
        this.api.postChatbotContextSearch(this.chatbotUuid!, prompt).subscribe({
          next: (r) => {
            const end = new Date()
            this.searchResults = r
            this.searchResultVars = r.map(item => item.collection)
            let total = 0
            r.forEach(item => {
              total += item.matches.length
            })
            this.searchResultsTotal = total
            this.searchDuration = (end.getTime() - start.getTime()) / 1000

            if (r.length) {
              this.selectSearchResultTab(r[0].collection)
            }
            else {
              this.resetSearchResultTab()
            }
            this.loading = false
          },
          error: (e) => {
            this.loading = false
            this.error = e
          }
        })
      }
    }
  }

  setActiveMainTab(tab: string) {
    this.activeTab = tab
    const queryParams: Params = { tab  };
    this.router.navigate(
      ['.'],
      {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      }
    ).finally(() => {
    })
  }

  selectSearchResultTab(collection: string) {
    this.searchResultTab = collection
    this.searchResultsActive = (this.searchResults || [])
      .find(r => r.collection == collection)
  }

  resetSearchResultTab() {
    this.searchResultTab = null
    this.searchResultsActive = undefined
  }

  ngOnInit(): void {
    this.chatbotUuid = this.route.snapshot.params['chatbotUuid']
    this.loader = this.api.getChatbot(this.chatbotUuid!)
    const tabFromQuery = this.route.snapshot.queryParams['tab']
    this.activeTab = tabFromQuery && this.tabs.includes(tabFromQuery) ? tabFromQuery : this.tabs[1]
  }

  protected readonly Object = Object;
}
